import { ArrowRight } from "lucide-react";
import { Article } from "../../../../shared/types/index.ts";
import { ArticleTypeLabels } from '../../../../shared/types/index.ts';
import { articleImageUrl } from '../../utils/articleImageUrl';

type ArticleCardProps = {
  article: Article;
}

export default function ArticleCard({ article}: ArticleCardProps) {
    const date = new Date(article.createdAt);
    const coverUrl = articleImageUrl(article?.images[0]?.url);
    return (
    <div 
      className="bg-white/80 h-full group transition-transform w-full duration-200 ease-in hover:-translate-y-1 backdrop-blur-sm rounded-lg shadow-sm overflow-hidden hover:shadow-md cursor-pointer"
    >
      <img src={coverUrl} alt={article.title} className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105" />
      <div className="flex flex-col flex-grow p-5 gap-1">
        <div className="flex mb-3 items-center ">
          <div className="flex gap-2 flex-wrap">
          {
            article.types.map(t => (
              <div className="rounded-full bg-blue-100/80 px-2 py-1 text-xs text-[#033c46]">{ArticleTypeLabels[t.type]}</div>
            ))
          }
          </div>
          <p className="text-sm text-gray-500 font-thin ml-auto">
            {
            date.toLocaleDateString
              ('en-US', 
                {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                }
              )
            }</p>
        </div>
        <h3 className="text-xl font-[1000] mb-2">{article.title}</h3>
        <p className="text-gray-700 text-[17px] line-clamp-3">{article.description}</p>
        <div className="group-hover:underline flex gap-2 items-center text-[#0e434d] pt-4 pb-2">
          <p className=" text-sm">Read More</p>
          <ArrowRight className="size-4"/>
        </div>

      </div>
    </div>
  );
}